import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import CustomTab from '../../../../../components/tab/CustomTab';
import CustomDataGrid from '../../../../../components/customized/customdatagrid/CustomDataGrid';
import CustomIconButton from '../../../../../components/buttons/CustomIconButton';
import UpdateYaantrac from './UpdateYaantrac';
import UpdateAutoplanner from './UpdateAutoplanner';
import UpdateLogistics from './UpdateLogistics';
import Trucks from '../../../../../../features/truckmanagement/pages/configurations/truck-zone/Trucks';
import { useAppSelector } from '../../../../../../app/redux/hooks';
import { getAllVehiclesAction } from '../../../../../../features/yaantrac/redux/reducer/yaantracSlices/overSpeedSlice';
import VehicleCard from './components/vehicleCard/VehicleCard';
import LoginRedirect from '../../../../../components/loginredirect/LoginRedirect';
import { useOverSpeedHooks } from './hooks/OverSpeedHooks';

function OverSpeed() {
  const roleType = localStorage.getItem('role');
  const vehicles = useAppSelector(state => state.getVechiles);
  const urls = {
    getVehicles: getAllVehiclesAction
  };

  let vehicleList =
    roleType === 'ROLE_LOGISTICS'
      ? [' Logistics']
      : roleType === 'ROLE_OPERATOR_ADMIN'
      ? ['Autoplanner']
      : ['Yaantrac'];

  const {
    handleUpdateIcon,
    handleVehicle,
    vehicleType,
    tabValue,
    tourismRows,
    type,
    setOpen,
    open,
    filteredRow
  } = useOverSpeedHooks(vehicles, urls);

  let autoplannerColumns = [
    {
      field: 'seatingCapacity',
      headerName: `Seating Capacity`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'isSurveillanceAvailable',
      headerName: `Surveillance`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'isWifiAvailable',
      headerName: `Wifi`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'isWheelchairAccessible',
      headerName: `Wheel Chair`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'isAc',
      headerName: `AC`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'update',
      headerName: `Update`,
      headerAlign: 'center',
      flex: 1,
      minWidth: 150,
      align: 'center',
      renderCell: (row: any) => (
        <Box>
          <CustomIconButton
            category='Update'
            showTooltip={false}
            onClick={(event: any) => {
              handleUpdateIcon(row, event);
            }}
          />
        </Box>
      )
    }
  ];

  return (
    <>
      <Box className='OverSpeed'>
        <Box sx={{ position: 'absolute', top: '10px', right: '20px' }}>
          <CustomTab onChange={handleVehicle} value={tabValue} tabList={vehicleList} />
        </Box>
        {vehicleType === 'Yaantrac' && <VehicleCard />}
        {vehicleType === 'Autoplanner' && (
          <CustomDataGrid
            rows={tourismRows}
            columns={autoplannerColumns}
            loading={vehicles.isLoading}
          />
        )}
        {vehicleType === 'Truck managementa' && <Trucks />}
      </Box>
      {open && (
        <>
          {type === 'Update Yaantrac' ? (
            <UpdateYaantrac
              open={open}
              setOpen={setOpen}
              roleType={type}
              filteredRow={filteredRow}
            />
          ) : type === 'Update Autoplanner' ? (
            <UpdateAutoplanner
              open={open}
              setOpen={setOpen}
              roleType={type}
              filteredRow={filteredRow}
            />
          ) : (
            <UpdateLogistics
              open={open}
              setOpen={setOpen}
              roleType={type}
              filteredRow={filteredRow}
            />
          )}
        </>
      )}
      <LoginRedirect />
    </>
  );
}

export default OverSpeed;
